import { render, staticRenderFns } from "./holandResult.vue?vue&type=template&id=ed0a9a40&scoped=true&"
import script from "./holandResult.vue?vue&type=script&lang=js&"
export * from "./holandResult.vue?vue&type=script&lang=js&"
import style0 from "./holandResult.vue?vue&type=style&index=0&id=ed0a9a40&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0a9a40",
  null
  
)

export default component.exports